<template>
    <div>
        <BaseLoading :visible="isLoading" />
        <base-modal :isOpen="isOpen" :title="$t('add_transaction') | capitalize" @close="$emit('close')">
            <!-- Body -->
            <template #body>
                <vs-row class="mb-2">
                    <vs-col class="px-2">
                        <label for="" class="custom-danger ml-2">{{ $t('client') | capitalize }}</label>
                    </vs-col>
                    <vs-col class="px-2">
                        <v-select class="w-full" label="client_name" :placeholder="$t('client') | capitalize"
                            v-model="client" :reduce="(item) => item.client_id" :options="clientList" clearable :disabled="isEditing">
                        </v-select>
                    </vs-col>
                </vs-row>
                <vs-row class="mb-2">
                    <vs-col class="px-2">
                        <label for="" class="custom-danger ml-2">{{ $t('amount') | capitalize }}</label>
                    </vs-col>
                    <vs-col class="px-2">
                        <vs-input type="number" placeholder="Amount" v-model="amount" class="w-full" />
                    </vs-col>
                </vs-row>

                <vs-row class="mb-2">
                    <vs-col class="px-2">
                        <label for="" class="custom-danger ml-2">{{ $t('currency') | capitalize }}</label>
                    </vs-col>
                    <vs-col class="px-2">
                        <vs-input placeholder="currencty" v-model="currency" class="w-full" disabled />
                    </vs-col>
                </vs-row>

                <vs-row class="mb-2">
                    <vs-col class="px-2">
                        <label for="" class="custom-danger ml-2">{{ $t('week') | capitalize }}</label>
                    </vs-col>
                    <vs-col class="px-2">
                        <v-select class="w-full" label="week" :placeholder="$t('week') | capitalize" v-model="week"
                            :reduce="(item) => item.week" :options="weekList" clearable :disabled="isEditing">
                        </v-select>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col class="px-2">
                        <file-uploader accept="application/pdf" :maxSize="2" @files-selected="handleFiles" />

                    </vs-col>
                </vs-row>
            </template>

            <!-- Footer -->
            <template #footer>
                <vs-button color="danger" type="border" @click="$emit('close')"> {{ $t('cancel') | capitalize }}
                </vs-button>
                <vs-button color="danger" @click="handleSubmit()" :disabled="isDisabled"> {{ $t('save') | capitalize }} </vs-button>
            </template>
        </base-modal>
    </div>
</template>

<script>
import BaseModal from '@/views/app/components/modals/BaseModal.vue'
import FileUploader from '@/views/app/components/upload/FileUploader.vue'
import vSelect from 'vue-select'
import request from '../request'
import BaseLoading from '@/views/app/components/loading/BaseLoading.vue';
export default {
    name: 'AddTransaction',
    components: { BaseModal, FileUploader, 'v-select': vSelect, BaseLoading},
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        clientList: {
            type: Array,
            default: () => []
        },
        weekList: {
            type: Array,
            default: () => []
        },
        isEditing: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => ({ client_id: null, prov_aguinaldo: '', week: null })
        }
    },
    data() {
        return {
            isLoading:false,
            selectedFiles: [],
            amount: '',
            client: null,
            week: null,
            currency: 'MXN',
        }
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.resetForm()
                if (this.isEditing) {
                    this.amount = this.formatAmount(this.item.prov_aguinaldo)
                    this.client = this.item.client_id
                    this.week = this.item.week
                }
            }

        }
    },
    computed:{
        isDisabled(){
            return this.amount === '' || this.amount < 0 || this.selectedFiles.length == 0 || this.client == null || this.week == null
        }
    },
    methods: {
        formatAmount(value) {
            return Number(value).toFixed(2);
        },
        resetForm() {
            this.selectedFiles = []
            this.amount = ''
            this.client = null
            this.week = null
        },
        handleFiles(files) {
            this.selectedFiles = files
        },
        handleSubmit() {
            const formData = new FormData()
            formData.append('file', this.selectedFiles[0])
            formData.append('client_id', this.client)
            formData.append('week', this.week)
            formData.append('amount', this.amount)
            this.isLoading = true
            request
                .uploadFile(formData)
                .then((response) => {
                    
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        text: 'Uploaded',
                    })
                    this.isLoading = false
                    this.$emit('close')
                    this.$emit('refresh')
                })
                .catch((response) => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'warning',
                        title: 'Opps!',
                        text: 'Some fields contain errors. Please review and try again.',
                        zIndex: 999999
                    })
                })

        },
    }
}

</script>

<style scoped>
::v-deep(.vs__dropdown-menu) {
    max-height: 50px;
    overflow-y: auto;
}
</style>
